// src/components/TableCajas.jsx
import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { getCajas, deleteCaja, getCajaById } from "../helpers/rutaCajas";
import ModalCaja from "./ModalCaja";
import "../css/tablecajas.css";

/* ========== CONFIG DE ANCHOS (tuneable) ========== */
const COLS = {
  acciones: 80,      // px
  nro: 40,           // px
  fecha: 80,        // px
  desc: 140,         // px
  tipo: 260,         // px
  montoIni: 120,     // px
  saldoAct: 120,     // px
};
/* ================================================ */

const TableCajas = () => {
  const [cajas, setCajas] = useState({ data: {}, loading: true });
  const [caja, setCaja] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaCajas();
  }, []);

  const consultaCajas = () => {
    getCajas().then((datos) => {
      setCajas({ data: datos, loading: false });
    });
  };

  const handleClose = () => {
    setShow(false);
    consultaCajas();
  };

  const handleShow = () => setShow(true);

  const modificaCaja = (id) => {
    getCajaById(id).then((resp) => {
      if (resp.ok) {
        setCaja(resp.caja);
        handleShow();
      } else {
        console.error("❌ Error al obtener caja:", resp.error);
      }
    });
  };

  const eliminarCaja = (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar la caja?");
    if (confirmar) {
      deleteCaja(id).then(() => consultaCajas());
    }
  };

  const renderTipo = (c) => {
    const tipo = (c?.tipo || "").toUpperCase();
    if (tipo === "BANCO") {
      const extra = c.alias || c.banco || c.numero;
      return `BANCO (transferencias)${extra ? ` – ${extra}` : ""}`;
    }
    return "CAJA (efectivo)";
  };

  const w = (px) => ({ width: px, minWidth: px, maxWidth: px });
  const cellClamp = (px) => ({
    ...w(px),
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  });

  return (
    <div className="table-container">
      {!cajas.loading && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th className="acciones col-actions" style={w(COLS.acciones)}>Acciones</th>
                  <th className="codcom col-nro" style={w(COLS.nro)}>Nro</th>
                  <th style={w(COLS.fecha)}>Fecha Caja</th>
                  <th style={w(COLS.desc)}>Descripción</th>
                  <th style={w(COLS.tipo)}>Tipo</th>
                  <th style={w(COLS.montoIni)}>Monto Inicial</th>
                  <th style={w(COLS.saldoAct)}>Saldo Actual</th>
                </tr>
              </thead>

              <tbody>
                {cajas.data.cajas?.map((c) =>
                  c.activo ? (
                    <tr key={c._id}>
                      <td className="acciones" style={w(COLS.acciones)}>
                        <button className="btn btn-primary" onClick={() => modificaCaja(c._id)}>
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>
                        {/* <button className="btn btn-danger ml-2" onClick={() => eliminarCaja(c._id)}>
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button> */}
                      </td>

                      <td style={cellClamp(COLS.nro)}>{c.codcaj}</td>

                      <td style={cellClamp(COLS.fecha)}>
                        {c?.fecha
                          ? new Date(c.fecha).toLocaleDateString("es-AR", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })
                          : "-"}
                      </td>

                      <td style={{ ...cellClamp(COLS.desc), whiteSpace: "normal" }}>
                        {c.descripcion}
                      </td>

                      <td style={cellClamp(COLS.tipo)}>{renderTipo(c)}</td>

                      <td style={{ ...cellClamp(COLS.montoIni), textAlign: "right" }}>
                        {c.montoInicial != null
                          ? c.montoInicial.toLocaleString("es-AR", {
                              style: "currency",
                              currency: "ARS",
                              minimumFractionDigits: 2,
                            })
                          : "-"}
                      </td>

                      <td style={{ ...cellClamp(COLS.saldoAct), textAlign: "right" }}>
                        {c.saldoActual != null
                          ? c.saldoActual.toLocaleString("es-AR", {
                              style: "currency",
                              currency: "ARS",
                              minimumFractionDigits: 2,
                            })
                          : "-"}
                      </td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>

          <ModalCaja show={show} handleClose={handleClose} caja={caja} />
        </>
      )}
    </div>
  );
};

export default TableCajas;
